// extracted by mini-css-extract-plugin
export default {"containprod":"eO","containprod2":"fO","title":"gO","servings":"hO","recommendation":"iO","image":"jO","flavorswrap":"kO","flavorsgroupwrap":"lO","moredetailsWrap":"mO","infoWrap":"nO","price":"oO","regularPrice":"pO","netPrice":"qO","addtocartcontainer":"rO","error":"sO"};
    if(module.hot) {
      // 1715188237898
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  